module.exports = __webpack_public_path__ + "img/google.fc27134a.webp";